import React from "react";

import Select from "react-select"
import { GlobalContext } from "../../../../utils/globalprovider.js";
import { apiGetClientsList } from "../../../../utils/apis.js";
import "./combos.css"

class ComboClient extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super (props);

        this.state = {
            clients: [],
            selectedClient: null, 
        }
        this.onGetTableList = this.onGetTableList.bind(this);
    }

    onGetTableList(datas)
    {

    var options = [
        {value:0, label:this.context.language=="fr"?"Non spécifié":"Unspecified"},
    
        ...datas.map(c => ({
            value: c.clid,
            label: c.clname,
            image: c.climage
            })),
        ]


    var selected = options.find(o => o.value === this.props.clientid);
    if (!selected) 
        selected = options.find(o => o.value === 0);

    this.setState( {
      options: options,
      selectedClient: selected,
    });        
        
    }

    customStyles = {
        container: (base) => ({
        ...base,
        width: "96.2%",
        marginLeft: "1%"
        }),

        control: (base) => ({
        ...base,
        border:  "none",
        boxShadow: "none",
        backgroundColor: "#000",
        color: "#fff",
        minHeight: "30px"
        }),

        singleValue: (base) => ({
        ...base,
        color: "#fff",
        fontSize: "13px"
        }),

        menu: (base) => ({
        ...base,
        backgroundColor: "#000"
        }),

        option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "#333" : "#000",
        color: "#fff",
        fontSize: "13px",
        cursor: "pointer"
        }),

        input: (base) => ({
        ...base,
        color: "#fff",
        fontSize: "13px"
        })
    };



    formatOptionLabel = ({ value,label, image }) => {

    const emptyImage =     "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";

    return (
                <div style={{ display: "flex", alignItems: "center" }}>
                <img
                    src={image ? image : emptyImage}
                    alt=""
                    style={{
                    width: 20,
                    height: 20,
                    marginRight: 8,
                    objectFit: "cover"
                    }}
                />
                <span>{value===0?"":String(value).padStart(4, " ")} &nbsp; {label}</span>
                </div>
            ) ;
    }
    
    
    handleChange = (selectedOption) => 
        {
    this.setState({ selectedClient: selectedOption });

    if (this.props.onChange)
        this.props.onChange (selectedOption.value);
    };

    componentDidMount()
    {
        // on lit la liste des clients (et clientes)
      apiGetClientsList (this.onGetTableList);
    }

    render()
    {

    return (
                    <Select
                    options={this.state.options}
                    value={this.state.selectedClient}
                    onChange={this.handleChange}
                    formatOptionLabel={this.formatOptionLabel}
                    styles={ this.customStyles}
                    />
    );    
    }
}


ComboClient.defaultProps = 
{ 
    clientid : -1,
}

export default ComboClient;
